<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useRouterStore } from './stores/router';
import { useUserStore } from './stores/user';

const router_store = useRouterStore();
const user_store = useUserStore();

const router = useRouter();

onMounted(() => {
    setTimeout(() => {
        user_store.check_userInfo();
    }, 0); // 需要再下一个线程进行，nextTick 没有效果
});


</script>

<style lang="less">
@import url('@/assets/styles/fonts.css');
@import url('@/assets/styles/general.css');

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    // scrollbar-width: thin; /* Firefox 支持的值：auto | thin | none */
    // scrollbar-color: var(--color-main-scrollbar-thumb) var(--color-main-scrollbar-track); /* Firefox：滑块颜色 + 轨道颜色 */
}

html,
body {
    width: 100%;
    min-width: var(--min-width-limit);
    height: 100%;
    position: relative;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    &::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
    }
}

ul {
    list-style: none;
}

a {
    color: #ffffff;
    text-decoration: none;
}

a:hover {
    color: #185cff;
}

// 修改全局滚动条样式
::-webkit-scrollbar {
    width: var(--scrollbar-width);
    /*对垂直流动条有效*/
    height: 7px;
    /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track {
    background-color: var(--color-main-scrollbar-track);
    border-radius: unset;
}

/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
    -webkit-box-shadow: var(--color-main-scrollbar-thumb-box-shadow);
    background-color: var(--color-main-scrollbar-thumb);
}

/*定义两端按钮的样式*/
::-webkit-scrollbar-button {
    display: none;
}

#app {
    font-family: 'Source Han Sans CN', sans-serif;
    // font-family: SourceHanSansCN, SourceHanSansCN;
    // font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI Variable', 'Segoe UI', system-ui, ui-sans-serif, Helvetica, Arial, sans-serif,
    //     'Apple Color Emoji', 'Segoe UI Emoji';
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--color-main-text-primary);
    width: 100%;
    min-width: var(--min-width-limit);
    height: 100%;
    text-align: left;
}

:root {
    --min-width-limit: 1280px;
    --cont-width-limit: 1200px;
    --nav-height: 96px;
    --scrollbar-width: 7px;
    --nav-z-index: 9999;
    --nav-menu-z-index: 99999;
    --login-z-index: 9999;
    --user-z-index: 9999;
    --dialog-z-index: 9999;
    --scorll-top-z-index: 9999;
    --breadcrumb-z-index: 21;
    --type-switch-z-index: 22;
    --update-version-z-index: 21;
    --dev-center-type-switch-z-index: 1;
    --home-partner-list-height-compute: 0;
    --d: 1200ms;
    --e: cubic-bezier(0.19, 1, 0.22, 1);

    --color-main-light-bg: #f8faff;
    --color-main-light-bg-white: #ffffff;
    --color-main-dark-bg: #0d0d0e;
    --color-main-dark-transparent-bg: rgba(0, 0, 0, 0.4);
    --color-main-gray-bg: #f2f3f5;
    --color-main-nav-light-bg: #ffffff;
    --color-main-nav-dark-bg: #0d0d0e;
    --color-main-transparent-bg: transparent;
    --color-main-black-bg: #000000;

    --color-main-brand: #185cff;
    --color-main-brand-hover: #467dff;
    --color-main-brand-hover-light: #e5edff;
    --color-main-brand-active: #185cff;

    --color-main-card-gradual-change: linear-gradient(24deg, #0065f4 0%, #0068f6 47%, #259cff 100%);
    --color-main-backdrop-filte: blur(7px);
    --color-main-login-backdrop-filter-background: linear-gradient(37deg, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0.1) 100%);
    --color-main-product-backdrop-filter-background: linear-gradient(137deg, rgba(0, 0, 0, 0.47) 0%, rgba(255, 255, 255, 0) 100%);
    --color-main-dev-center-backdrop-filter-background: linear-gradient(137deg, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0) 100%);
    // --color-main-card-shadow-big: 0px 3px 6px 0px rgba(41, 72, 152, 0.01), 0px 16px 12px 0px rgba(41, 72, 152, 0.02);
    --color-main-card-shadow-big: 0px 3px 6px 0px rgba(41, 72, 152, 0.02), 0px 16px 12px 0px rgba(41, 72, 152, 0.08);
    --color-main-card-shadow-small: 0px 3px 6px 0px rgba(41, 72, 152, 0.01), 0px 16px 12px 0px rgba(41, 72, 152, 0.04);
    --color-main-card-shadow-small-small: 0px 2px 4px 0px rgba(41, 72, 152, 0.01), 0px 4px 8px 0px rgba(41, 72, 152, 0.04);
    --color-main-scroll-top-shadow: 0px 1px 4px 0px rgba(71, 100, 254, 0.1), 0px 2px 8px 0px rgba(71, 100, 254, 0.3);
    --color-main-dev-center-course-shadow: 0px 1px 2px 0px rgba(71, 100, 254, 0.1), 0px 2px 4px 0px rgba(71, 100, 254, 0.3);
    --color-main-nav-shadow: 0px 3px 5px 0px rgba(41, 72, 152, 0.01), 0px 14px 11px 0px rgba(41, 72, 152, 0.02),
        0px 167px 133px 0px rgba(41, 72, 152, 0.05);
    --color-main-gradual-change-bg: url(@/assets/imgs/general/gradual_change_bg.png) no-repeat center center / cover;

    --color-main-md-code-bg: #f7faff;
    --color-main-tree-cell-bg-default: #f7faff;
    --color-main-tree-before-bg: #cccccc;
    --color-main-doc-eltree-cell-bg: #f7faff;
    --color-main-doc-remark-bg: #f7faff;
    --color-main-doc-segmentation-line-bg: #cccccc;
    --color-main-doc-switch-item-bg: rgba(0, 0, 0, 0.09);
    --color-main-msg-green-bg: #32e6a3;
    --color-main-msg-red-bg: #d90000;
    --color-main-dev-center-switch-item-bg: rgba(255, 255, 255, 0.13);
    --color-main-dev-center-faq-bg: #f3f3f3;
    --color-main-product-func-morebtn-bg: #e4f0ff;
    --color-main-product-func-detail-line: rgba(22, 22, 22, 0.2);
    --color-main-product-func-morebtn-bg-hover: rgba(228, 240, 255, 0.8);
    --color-main-home-performance-line: #8e8e8e;
    --color-main-home-partner-more-btn-bg: #e4f0ff;

    --color-main-text-primary: #161616; //主要文字色彩&标题色
    --color-main-text-disabled: #bdbdbd; //文字disabled态
    --color-main-text-secondary: #5d5f64; //次要文字色彩&辅助文案色
    --color-main-text-brand: #185cff; //主题文案色
    --color-main-text-brand-bg-primary: #ffffff; //主题色背景下文字主色
    --color-main-text-brand-bg-secondary: rgba(255, 255, 255, 0.8); //主题色背景下文字副色
    --color-main-text-dark-bg-primary: #ffffff; //文字反色色彩1&深色背景下文字主色
    --color-main-text-dark-bg-secondary: #f3f3f3; //文字反色色彩2&深色背景下文字辅助文案色
    --color-main-text-nav-light-bg-default: #1b2559; //头部导航条选项字体默认色/浅色主题
    --color-main-text-nav-dark-bg-default: rgba(255, 255, 255, 0.8); //头部导航条选项字体默认色/神色主题
    --color-main-text-nav-dark-bg-default-selected: #ffffff; //头部导航条选项字体默认色/神色主题hover/sel
    --color-main-text-nav-default: #1b2559; //头部导航条选项字体默认色
    --color-main-text-nav-selected: #185cff; //头部导航条选项字体选中色
    --color-main-text-footer-default: #dcdcdc; //footer文字默认色
    --color-main-text-footer-selected: #ffffff; //footer文字选中/hover
    --color-main-text-footer-secondary: #5d5f64; //footer 线/辅助文字
    --color-main-text-search: #777777; //搜索框提示文字
    --color-main-text-banner-title: #292d33; //产品功能页banner标题色
    --color-main-text-banner-dis: #9497a1; //产品功能页banner辅助文案色
    --color-main-text-link: #185cff; //链接文字色
    --color-main-text-home-dis: #8e8e8e; //首页描述
    --color-main-text-home-secondary: rgba(22, 22, 22, 0.8); //首页副标题

    --color-main-scrollbar-transparent: transparent;
    --color-main-scrollbar-track: transparent;
    --color-main-scrollbar-track-white: #ffffff;
    --color-main-scrollbar-thumb: #e5edff;
    --color-main-scrollbar-thumb-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    --color-main-border-transparent: transparent;
    --color-main-border-white: #ffffff;
    --color-main-border-gray: #cccccc;
    --color-main-border-eltree-gray: #cccccc;
    --color-main-outline-hover: rgba(24, 92, 255, 0.1);
    --color-main-bg-transparent: transparent;
    --color-main-login-bg-dark-transparent: rgba(0, 0, 0, 0.2);

    --font-elbtn-title-size20: 20px;
    --transform-scale-105: scale(1.05);
    --transform-scale-120: scale(1.2);
    --animation-border-style: border 0.3s linear;
    --animation-margin-style: margin 0.3s linear;
    --animation-transform-style: transform 0.3s linear;
    --animation-height-style: height 0.3s ease-in-out;
    --animation-top-style: top 0.5s ease-in-out;
    --animation-background-color-style: background-color 0.2s linear;
    --animation-opacity-style: opacity 0.5s ease-in-out;
    --animation-outline-style: outline 0.3s ease-in-out;
}

input,
input:hover,
input:focus {
    background-color: transparent !important;
    border-width: 0;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}

/* Firefox样式 */
@supports (scrollbar-color: red black) and (not selector(::-webkit-scrollbar)) {
    * {
        scrollbar-width: thin; /* Firefox 支持的值：auto | thin | none */
        scrollbar-color: var(--color-main-scrollbar-thumb) var(--color-main-scrollbar-track); /* Firefox：滑块颜色 + 轨道颜色 */
    }
}
</style>
